export default [
    // "WIFI",
    // "WIFIHK",
    // "GOVWIFI",
    // "TOI",
    // "CTRY_TOI",

    "3AE",
    "3CP",
    "AQMN",
    "ASFPS",
    "BC",
    "BDC",
    "BDGFA",
    "BDLSMW",
    "BDPOS",
    "BDR",
    "BMINC",
    "BO",
    "CAAB",
    "CASD",
    "CCC",
    "CCSPP",
    "CHILD",
    "CLINIC",
    "SOCLINIC",
    "CLINIC_HEALTH",
    "KAR",
    "CMCTR",
    "COVID19_CTC",
    "COVID19_DPCPS",
    "COVID19_MDPCPS",
    "COVID19_SCP",
    "CP",
    "CPI",
    "CPM",
    "CPO",
    "CPWDL",
    "CRDC",
    "CRN",
    "CSC",
    "CSSP",
    "CST",
    "CSTEC",
    "CTRY_TOI",
    "CVS",
    "CYCSITE",
    "DAC",
    "DCTC",
    "DO",
    "DOSO",
    "DO_NGO",
    "DSCPD",
    "DSWO",
    "EERC",
    "EETC",
    "EHS",
    "ELDERLY",
    "EPTG",
    "ELEC",
    "ELMC",
    "ESWC",
    "FCPSU",
    "FITNESS",
    "GOVWIFI",
    "GPL",
    "HEERC",
    "HKORC",
    "HMMH",
    "HQ",
    "HSMH",
    "HSPH",
    "HSPH_MH",
    "HWH",
    "HWH_SP",
    "ICA",
    "ICCMW",
    "IFS",
    "ILSP",
    "IRO",
    "IRSC",
    "IVRSC",
    "IVTC",
    "JC",
    "JUD",
    "LAO_LSR",
    "LAOLEC",
    "LAOLMC",
    "LAO_CTOAP",
    "LAO_CTOAW",
    "LAO_PCNRDP",
    "LAO_PCNRDW",
    "LAO_PCRDP",
    "LAO_PCRDW",
    "LAO_CTOA",
    "LAO_PCNRD",
    "LAO_PCRD",
    "LAO_PCDOMC",
    "LBA",
    "LG",
    "LO",
    "LRY",
    "LRO",
    "MHCCC",
    "MR",
    "MSC",
    "MSO",
    "MSS",
    "NSCCP",
    "OFACI",
    "OSA",
    "PAA",
    "PESC",
    "PO",
    "POLICE",
    "PRC",
    "RCP",
    "ROPO",
    "RP",
    "RRU",
    "RSCCC",
    "RTC",
    "SCCC",
    "SCCO",
    "SE",
    "SER",
    "SHOS",
    "SICRC",
    "SMK",
    "SPB",
    "SQUASH",
    "SRCS",
    "SS",
    "SSAB",
    "SSCEC",
    "SSR",
    "SW",
    "TAN",
    "TAVAS",
    "TDCBU",
    "TDDOPO",
    "TDDSS",
    "TDDTAWT",
    "TDLRO",
    "TC",
    "TCSC",
    "TENNIS",
    "TMP",
    "TOI",
    "VPT",
    "VTI",
    "WALL",
    "WIFI",
    "YOUTH",
    "WIFIHK",
    "PF",
    "RNCPM",
    "CAM",
    "CMS",
    "CRA",
    "CTR",
    "DLO",
    "DOF",
    "FER",
    "HKJCDIC",
    "HLP",
    "HSA",
    "LRA",
    "LRE",
    "MTA",
    "NRA",
    "PAG",
    "PIE",
    "ROI",
    "RPT",
    "TNC",
    "VOF",

]